import axios from "axios";
import store from "../Store";
import Config from "./Config";
import { encrypt } from "./Crypto";
import { getCookie } from "./Utils";
import { authChange } from "../Reducer/componentSlice";
import { SESSION_END_CODES, endSession } from "./webSession";

const ApiCall = axios.create({
    baseURL: Config.URL.BACKEND_URL,
    timeout: 20000,
    headers: { "Content-Type": "application/json" },
});

ApiCall.interceptors.request.use(
    (config) => {
        const token = getCookie("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        if (config?.formdata) {
            config.headers["Content-Type"] = "multipart/form-data";
        } else if (["post", "patch", "put"].includes(String(config?.method).toLowerCase())) {
            config.data = encrypt(config?.data);
        }
        return config;
    },
    (error) => Promise.reject(error)
);

ApiCall.interceptors.response.use(
    (response) => response.data,
    (error) => {
        const status = error?.response?.status;
        // 401 = session/token invalid -> force re-login (with a code: back to the sign-in page saying why).
        // 403 = authenticated but lacks a specific ACL capability for this one
        // action -> let the calling component handle it (toast/empty-state),
        // do NOT log the whole console out over one denied permission.
        if (status === 401 && !error?.config?.silent) {
            const code = error?.response?.data?.code;
            const sent = String(error?.config?.headers?.Authorization || "").replace(/^Bearer\s+/i, "");
            if (sent && SESSION_END_CODES.has(code)) {
                // The server ended this sign-in (idle, 12-hour limit, signed out elsewhere, password changed ...).
                // A call that left with an older token than the cookie now holds is ignored: the person has signed
                // in again in another tab since.
                if (sent === getCookie("token")) endSession({ code, message: error?.response?.data?.message });
            } else {
                store?.dispatch(authChange(false));
            }
        }
        return Promise.reject(error);
    }
);

export default ApiCall;
